import React from 'react';
import styled from 'styled-components';
import { fadeOut, fonts } from '../GlobalStyle';
import { calc4k } from '../utilities';

export default function Time_({ time, period }) {
    return (
        <Container>
            <TimePeriodContainer>
                {time}
                <TimePeriod>{period}</TimePeriod>
            </TimePeriodContainer>
        </Container>
    );
}

const Container = styled.h3`
    font-family: ${fonts.headline};
    margin-top: ${calc4k(660)};
    font-size: ${calc4k(97)};
    animation: ${fadeOut} 1200ms ease-in-out;
`;

const TimePeriodContainer = styled.span`
    display: inline-block;
    position: relative;
    width: 100%;
    height: 100%;
`;

const TimePeriod = styled.span`
    display: inline-block;
    /* margin-left: 0.16vw; */
    /* top: 0.95vh; */
    /* position: absolute; */
    font-size: ${calc4k(57)};
    text-transform: uppercase;
`;
